import {combineReducers} from 'redux';
import imageMorpher from './imageMorpher';

const rootReducer = combineReducers({
    imageMorpher
});

export default rootReducer;